/**
 * @title  validators
 * @author Holger Schauf
 * @type   module
 * @desc   list of form validators
 * @date   06.2013
 */
var validators = (function ($) {
    return {
        remoteValidation: function (url, params, errorElement, elm) {
            var self = this;
            var validationData = new FormData();

            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    validationData.append(key, params[key]);
                }
            }

            fetch(url, {
                method: 'post',
                body: validationData,
            })
                .then(function (res) {
                    return res.json();
                })
                .then(function (data) {
                    data = data.result;
                    if (data.status === 'success') {
                        errorElement.hide();
                        errorElement.prev('i').hide();
                        return true;
                    } else if (
                        data.status === 'failure' &&
                        params.email !== ''
                    ) {
                        self.showErrorMessage(
                            elm,
                            errorElement,
                            js_tr.error[data.reason]
                        );
                        return false;
                    }
                    return true;
                });
        },

        showErrorMessage: function (elm, errorElement, text) {
            elm.parent().find('.icon-ok').hide();
            elm.parent().addClass('error error-type');
            if (errorElement.prev('i').length > 0) {
                errorElement.find('p').html(text);
                errorElement.show();
                errorElement.prev('i').show();
            } else {
                errorElement.html(text).show();
            }
        },

        required: function (i, elm) {
            switch (elm.attr('type')) {
                case 'checkbox':
                case 'radio':
                    return elm.is(':checked');

                default:
                    return elm.val().length > 0;
            }
        },

        minlength: function (min, elm) {
            return String(elm.val()).length >= min;
        },

        maxlength: function (max, elm) {
            return String(elm.val()).length <= max;
        },

        match: function (match, elm) {
            return null !== elm.val().match(match);
        },

        mail: function (elm) {
            var params = {
                email: elm.val(),
            };

            if (ApplicationProperties.get('newRegexForEmail')) {
                params.newRegexForEmail = 1;
            }

            var emailError = elm.parent().find('.error-message-type');

            if (elm.val() !== '') {
                this.remoteValidation(
                    window.location.origin + '/ajax/emailcheck.php',
                    params,
                    emailError,
                    elm
                );
            }

            return this.pureMail(elm.val());
        },

        pureMail: function (email) {
            var re =
                /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (ApplicationProperties.get('newRegexForEmail')) {
                re =
                    /^[\p{L}\x2d-9!-\'\*\=+\\?^-~]+(\.[\p{L}\x2d-9!-\'\*\=+\\?^-~]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            }
            return re.test(email);
        },

        zipcode: function (elm) {
            if (
                elm[0].name !== 'zipcode' ||
                'DE' !== $('#customerCountry').val()
            ) {
                return true;
            }
            return (
                null !==
                elm
                    .val()
                    .match(
                        $('#customerCountry option')
                            .filter(':selected')
                            .attr('data-regex')
                    )
            );
        },

        creditcard: function (elm) {
            var elmTrimValue = elm.val().replace(/\s+/g, '');
            var regEx =
                '^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\\d{3})\\d{11})$';
            return null !== elmTrimValue.match(regEx);
        },

        driverNameIsCcName: function (elm) {
            if (elm.data('checkname') !== undefined) {
                var driverName =
                    $.trim($('#customerForname').val()) +
                    ' ' +
                    $.trim($('#customerSurname').val());
                if ($('#customerSurname').val() === '') {
                    driverName = $.trim($('#customerForname').val());
                }
                return $.trim(elm.val()) === driverName;
            }
        },

        driverNameIsCcSurAndLast: function (elm) {
            var ccName =
                $.trim($('#customerCreditcardownerForname').val()) +
                ' ' +
                $.trim($('#customerCreditcardownerSurname').val());
            var driverName =
                $.trim($('#customerForname').val()) +
                ' ' +
                $.trim($('#customerSurname').val());
            return ccName === driverName;
        },

        banknumber: function (elm) {
            var regEx = '[1-9]{1,1}[0-9]{7,7}';
            return null !== elm.val().match(regEx);
        },

        phoneNumber: function (elm) {
            var regEx = '^([0-9\\s-+\\/]*)$';
            return null !== elm.val().match(regEx);
        },

        cvcNumber: function (elm) {
            var regEx = '\\d{' + elm.attr('maxlength') + '}';
            return null !== elm.val().match(regEx);
        },

        pciCreditCardType: function (elm) {
            return window.stj.pci.currentCcType === elm.val();
        },

        pciCreditCardNumber: function () {
            return window.stj.pci.hasCardNumberError === false;
        },

        pciCvvNumber: function () {
            return window.stj.pci.hasCvvNumberError === false;
        },

        password: function (elm) {
            var regEx = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,}$/;
            return null !== elm.val().match(regEx);
        },

        age: function (elm, self) {
            var year = null;
            var month = null;
            var day = null;

            self.elm.each(function () {
                if ($(this).data('type') === 'year') {
                    year = $(this).val();
                } else if ($(this).data('type') === 'month') {
                    month = $(this).val();
                } else if ($(this).data('type') === 'day') {
                    day = $(this).val();
                }
            });

            if (day === null || month === null || year === null) {
                return false;
            }

            var birthDate = {
                year: year,
                month: month,
                day: day,
            };

            this.replaceMinAgeLink(birthDate);

            var offerIsValidForCustomer =
                this.isOfferValidForCustomer(birthDate);

            if (!offerIsValidForCustomer && stj.personalInfo) {
                stj.personalInfo.trackYoungDriverAction('showHint');
            }

            return offerIsValidForCustomer;
        },

        isOfferValidForCustomer: function (birthDate) {
            var currentDate = stj.global.getCurrentDate();
            var dep = this.getDepDate();

            var offerIsValidForCustomer = this.isAgeDifferenceBiggerThan(
                currentDate,
                birthDate,
                18
            );

            if (
                stj.personalInfo &&
                stj.personalInfo.youngDriverAgeLimit > 0 &&
                offerIsValidForCustomer
            ) {
                offerIsValidForCustomer = this.isAgeDifferenceBiggerThan(
                    dep,
                    birthDate,
                    stj.personalInfo.youngDriverAgeLimit
                );
            }
            return offerIsValidForCustomer;
        },

        isAgeDifferenceBiggerThan: function (from, to, minAge) {
            var currentToBirthDiff = this.getAgeDiff(from, to);
            return currentToBirthDiff >= minAge;
        },

        ccDateValid: function () {
            return stj.personalInfo && !stj.personalInfo.isCcExpiredNow();
        },

        getAgeDiff: function (from, to) {
            var diffInYears = from.year - to.year;

            if (from.month < to.month) {
                diffInYears--;
            } else if (from.month === to.month && from.day < to.day) {
                diffInYears--;
            }

            return diffInYears;
        },

        replaceMinAgeLink: function (birthDate) {
            var customerAgeFilter = $('#customerAgeFilter');
            if (!customerAgeFilter.length) {
                return;
            }
            var currentDate = stj.global.getCurrentDate();
            var customerAge = this.getAgeDiff(currentDate, birthDate);
            var url = customerAgeFilter.attr('href');
            url = url.replace(/&customerAge=(\d+)/g, '');
            url += '&customerAge=' + customerAge;

            customerAgeFilter.attr('href', url);
        },

        getDepDate: function () {
            if (stj.personalInfo) {
                return {
                    year: stj.personalInfo.depYear,
                    month: stj.personalInfo.depMonth,
                    day: stj.personalInfo.depDay,
                };
            }
            return stj.global.getCurrentDate();
        },
    };
})(jQuery);
